import { render, staticRenderFns } from "./EngineFaultsData.vue?vue&type=template&id=a51c2f54&scoped=true"
import script from "./EngineFaultsData.vue?vue&type=script&lang=js"
export * from "./EngineFaultsData.vue?vue&type=script&lang=js"
import style0 from "./EngineFaultsData.vue?vue&type=style&index=0&id=a51c2f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c2f54",
  null
  
)

export default component.exports